import useFeatureFlagsStore from 'stores/use-feature-flags-store';

/**
 * Reads a runtime feature flag from the post-auth map, defaulting to `false`
 * (fail closed). The map is fetched once on login and cached, so a flag change
 * takes effect on next reload.
 */
export const useFeatureFlag = (name: string): boolean =>
  useFeatureFlagsStore((s) => s.flags[name] ?? false);
